import { render } from "./ListPage.vue?vue&type=template&id=b912a4ea"
import script from "./ListPage.vue?vue&type=script&lang=js"
export * from "./ListPage.vue?vue&type=script&lang=js"

import "./ListPage.vue?vue&type=style&index=0&id=b912a4ea&lang=css"
script.render = render

export default script